<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar color="white" flat>
          <v-icon color="black">settings</v-icon>
          <v-toolbar-title>
            <h2>Point Management</h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            placeholder="Search firstname, lastname, tel."
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="isTableLoading"
      :items="filterSearch"
      :pagination.sync="pagination"
      :rows-per-page-items="[10,25]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ customerData.indexOf(props.item)+1 }}</td>
        <td class="text-xs-left">{{ props.item.user_first_name }}</td>
        <td class="text-xs-left">{{ props.item.user_last_name }}</td>
        <td class="text-xs-left">{{ props.item.user_country_tel+props.item.user_tel }}</td>
        <td class="text-xs-center">
          <v-btn @click="openDialogDetailCustomer(props.item)" icon>
            <v-icon color="black" small>remove_red_eye</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <DetailCustomerDialog
      :isLoading="isLoading"
      :eachCustomer="eachCustomer"
      :pointManageData="pointManageData"
      :openDialog="openDialog"
      @closeDiaglog="closeDialogDetailCustomer"
      @fetchPointList="fetchPointList"
    />
  </div>
</template>

<script>
import DetailCustomerDialog from "@/components/back-office/PointManage/DetailCustomerDialog";
import { mapState } from "vuex";
export default {
  created() {
    this.fetchCustomerData();
  },
  components: {
    DetailCustomerDialog
  },
  data() {
    return {
      eachCustomer: {},
      openDialog: false,
      search: "",
      pagination: {
        rowsPerPage: 10
      },
      isTableLoading: false,
      headers: [
        {
          text: "No",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Firstname",
          align: "left",
          sortable: false,
          value: "user_first_name"
        },
        {
          text: "Lastname",
          align: "left",
          sortable: false,
          value: "user_last_name"
        },
        {
          text: "Tel.",
          align: "left",
          sortable: false,
          value: "user_tel"
        },
        {
          text: "Detail",
          align: "center",
          sortable: false
        }
      ],
      isLoading:false,
      paramsPointList: {},
      valid: false,
      showContent: false,
      txtFieldTel: "",
      rules: {
        max: v =>
          (v && v.length <= 9) ||
          "หมายเลขโทรศัพท์ผิดพลาด (** หมายเลข 9 หลักเท่านั้น)",
        min: v => (v && v.length >= 9) || "กรุณากรอกหมายเลขให้ครบ 9 หลัก",
        required: v => !!v || "กรุณากรอกข้อมูล"
      }
    };
  },
  computed: {
    ...mapState({
      customerData: state => state.fetchCustomerBack.customerData,
      pointManageData: state => state.pointmanage.pointManageData
    }),
    filterSearch() {
      return this.customerData.filter(
        data =>
          (data.user_country_tel + data.user_tel)
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          (data.user_first_name + " " + data.user_last_name)
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    fetchPointList(data) {
      this.$store.dispatch("pointmanage/getPointManageData", data);
    },
    async openDialogDetailCustomer(data) {
      this.eachCustomer = JSON.parse(JSON.stringify(data));
      let configPath = {
        tel: this.eachCustomer.user_tel,
        countPoint: 0,
        countPointExchange: 0
      };
      this.isLoading = true
      await this.$store.dispatch("pointmanage/getPointManageData", {
        configPath,
        type: "",
        isFirsttime: true
      });
       this.isLoading = false
      this.openDialog = true;
    },
    closeDialogDetailCustomer(value) {
      this.openDialog = !value;
    },
    async fetchCustomerData() {
      this.isTableLoading = true;
      await this.$store.dispatch("fetchCustomerBack/getData");
      this.isTableLoading = false;
    }
  }
};
</script>

<style scoped></style>
